import { createFileRoute } from "@tanstack/react-router";
import { AppShell } from "@/components/layout/app-shell";
import { requireRole } from "@/features/auth/guards";

/** The Motherhood portal layout. Guarded by role; renders the shared app shell. */
export const Route = createFileRoute("/_authenticated/admin")({
  beforeLoad: () => requireRole("super_admin"),
  component: () => <AppShell portal="admin" />,
});
